import {Module} from 'module/Module'
import {EntryDescReducerNS} from 'module/edesc/reducer/EntryDescReducer'
import {entryDescEpic} from 'module/edesc/epic/EntryDescEpic'

export const EntryDescModule: Module = {
	reducerNS: EntryDescReducerNS,
	epics: [entryDescEpic],
}